module.exports = __webpack_public_path__ + "img/project_15.981e8cc5.jpg";